import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { DocumentEditComponent } from '@fi-app/document/edit/edit.component';
import { DocumentService } from '@fi-app/document/document.service';
import { FiDocumentStatesResolveDefaultDocumentSettings } from '@fi-app/document/states/resolve/default-document-settings';
import { FiDocumentStatesResolveDefaultTemplateSettings } from '@fi-app/document/states/resolve/default-template-settings';
import { FiDocumentStatesResolvePageTitle } from '@fi-app/document/states/resolve/document-page-title';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiDocumentStatesResolveDocumentTemplates } from '@fi-app/document/states/resolve/document-templates';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDocumentStatesResolveRecentAIRequests } from '@fi-app/document/states/resolve/recent-ai-requests';

export const FiDocumentCopyState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Copy,
    url: '/:Id/Copy?languageId',
    reloadOnSearch: false,
    views: {
        '@': {
            component: DocumentEditComponent,
        },
    },
    resolve: {
        document: [DocumentService, FiStateService, Transition, FiDocumentCopyStateResolveDocumentResolveFunc],
        defaultDocumentSettings: FiDocumentStatesResolveDefaultDocumentSettings,
        defaultTemplateSettings: FiDocumentStatesResolveDefaultTemplateSettings,
        pageTitle: FiDocumentStatesResolvePageTitle,
        documentTemplates: FiDocumentStatesResolveDocumentTemplates,
        recentAIRequests: FiDocumentStatesResolveRecentAIRequests,
    },
};

export function FiDocumentCopyStateResolveDocumentResolveFunc(
    documentService: DocumentService,
    fiStateService: FiStateService,
    $transition$,
) {
    const params = fiStateService.getParams($transition$);
    return documentService.GetDocumentCopy(params.Id, params.languageId);
}
